var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'flag-icon',
    ("flag-icon-" + (_vm.$_.toString(_vm.countryCode).toLowerCase())),
    _vm.isSquared && 'flag-icon-squared'
  ]})}
var staticRenderFns = []

export { render, staticRenderFns }